import { Component, OnInit, HostListener, TemplateRef, OnDestroy, ViewChild, Input } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { IApproval, IAppByRole, IEmployee, IDocument } from 'src/app/_services/ApplicationServices/approval';
import { LoginService } from 'src/app/_services/ApplicationServices/login.service';
import { Router } from '@angular/router';
import { ApprovalService } from 'src/app/_services/ApplicationServices/approval.service';
import { AppInsightsService } from 'src/app/_services/ReportServices/app-insights.service';
import { DelegationReportsService } from 'src/app/_services/ApplicationServices/delegation-reports.service';
import { DelegationReportdata, RecentDelegatee } from 'src/app/_services/ApplicationServices/delegation-reports';
import { JsonPipe, Location } from '@angular/common';
import { DelegationReportFiltersdata } from 'src/app/_services/ApplicationServices/delegation-report-filter';
import { MessageService } from 'primeng/api'
import { AppId, SAPID } from 'src/app/_shared/common/global-variables';
import { newId } from '@microsoft/applicationinsights-core-js';
import { ExcelService } from 'src/app/_services/CommonServices/excel.service';
import { QuickDeligationService } from 'src/app/_services/ApplicationServices/quick-delegation.service';
import { formatDate } from '@angular/common';
import { IntegratedAppDetails } from 'src/app/_services/ApplicationServices/quick-delegation';
//import { NgxSpinnerModule } from "ngx-spinner";  
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-approval',
    templateUrl: './approval.component.html',
    styleUrls: ['./approval.component.css'],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateX(100%)' }),
                animate('200ms ease-in', style({ transform: 'translateX(0%)' }))
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ transform: 'translateX(100%)' }))
            ])
        ]),
        trigger('animateWdth', [
            transition(':enter', [
                style({ width: '0px' }),
                animate('200ms ease-in', style({ width: '140px' }))
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ width: '0px' }))
            ])
        ])
    ],
    standalone: false
})
export class ApprovalComponent implements OnInit {
  rejectModal2: any;
  addClassToBody() {
    throw new Error('Method not implemented.');
  }
  visible: any;
  brand: any;
  showDialog() {
    throw new Error('Method not implemented.');
  }

  //products: Product[] | undefined;

  responsiveOptions: any[] | undefined;
  productService: any;


  config = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  visibleSidebar1: any;
  visibleSidebar2: any;
  itemsPerSlide: number;
  itemsPerSlideRequest: number;
  singleSlideOffset = true;
  noWrap = false;

  SapId: string;
  EmployeeName: string;
  EmployeeSubGroup: string;
  OnBehalf: boolean = false;
  Designation: string;
  getpending: Subscription;
  getRequest: Subscription;
  public showContent: boolean = false;
  subscriptionPendingRequest: Subscription;
  subscriptionRoleByPending: Subscription;
  subScriptionMyRequests: Subscription;
  subScriptionRoleByRequest: Subscription;
  subScriptionDocumentNameDetails: Subscription;
  employeeId: string;
  deploymentTime: number = Date.now();
  myPendingApprovals: IApproval[];
  filteredMyPendingApprovals: IApproval[];
  topFiveApprovalData: IApproval[];
  topFiveMyRequestData: IApproval[];
  myRequests: IApproval[];
  filteredMyRequests: IApproval[];
  roleByAppSlider: IAppByRole[];
  roleByAppSlierApprovalLength;
  roleByAppSliderMyRequest: IAppByRole[];
  roleByAppSliderLength;
  application;
  Role;
  Status;
  PendingStatus;
  mypendingApplication;
  mypendingRole;
  totalRows: number;
  totalRequestRows: number;
  errorMessage: string;
  _filterMyRequest: string;
  _listFilter: string;
  _requestId: string = null;
  _applicationList: string = null;
  _roleName: string = null;
  _status: string = null;
  appddldata: IApproval[];
  roleddldata: IApproval[];
  _pendingrequestId: string = null;
  _pendingRoleName: string = null;
  _pendingapplicationList: string = null;
  delReqId: number;
  hiddenBtn: boolean = true;
  ValidationMessage: string = '';
  activeSubmitButton: boolean = true;
  activeCancelBtn: boolean = true;
  isCheckedHeader: boolean;
  rejectRemarks: string = '';
  rejectBulkRemarks: string = '';
  listRejectRequest: IEmployee[] = [];
  listAllApproveRequest: IEmployee[] = [];
  listApproveRequest: IEmployee[] = [];
  gridcheckval: boolean;
  spaceValue = "-";
  cancelRemarks: string = " ";
  canValMessage: string = " ";
  totaldata: number;
  setcancelId: number;
  myDocuments: string;
  sendfilename: IDocument[] = [];
  filename: any;
  dwnldFile: string;
  downloadsapid: IEmployee[] = [];
  downloadextensionsapid: string;
  datetoday: any;
  previousUrl: string;
  viewLessMyApproval = false
  viewAllMyApproval
  totaldataMyApproval: number;
  delegateeTextvalue: string = '';
  delegateegridTextvalue: string = '';
  requestIdTextValue: string = null;
  recentDelegatee: RecentDelegatee[] = [];
  brands: string[];
  mailerData: any;
  delegateeSapId: string = null;
  RemarksCheck: boolean = false;
  filteredBrands: any[];
  filteredGridBrands: any[];
  IstopFiveApprovalData: boolean;
  IstopFiveMyRequestData: boolean;
  //@Input() wordLimit : number;


  //  Search
  search = false
  hideBtn = true
  openSearch(event) {
    event.stopPropagation();
    this.search = !this.search
    this.hideBtn = !this.hideBtn
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this.search = false
    this.hideBtn = true
  }

  // Textclear
  serachT;
  textClear(event) {
    event.stopPropagation();
    this.serachT = ""
  }
  //  Search END
  myPendingfilter = false
  openMyPendingFilter() {
    this.myPendingfilter = !this.myPendingfilter
  }


  //  FILTER
  filter = false
  openFilter() {
    this.filter = !this.filter
  }

  //  FILTER End

  /* MODAL */
  modalRef: BsModalRef;
  // success
  sucImg = "assets/images/tick.gif";
  success(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: 'successM' })
    );
  }

  // Alert 
  alertIcon = "assets/images/alert-01.svg";
  alert(template: TemplateRef<any>) {

    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: 'alertM' })
    );
  }

  alertbulk(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: 'alertM' })
    );
    setTimeout(() => {
      this.modalRef.hide();
    }, 3000);
  }

  // Modal Extend 
  openDialog(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: 'modal-md' })
    );
  }

  // Active
  selectedIndex: number = 0;
  subModules = [{ name: "1 Month" }, { name: "3 Months" }, { name: "6 Months" }, { name: "1 Year" }]

  setIndex(index: number) {
    this.selectedIndex = index;

  }

  // textarea
  maxChars = 500;
  role = '';
  chars = 0;


  // View Card
  viewLess = true
  viewAll
  // viewll() {
  //   this.viewAll = !this.viewAll
  //   this.viewLess = !this.viewLess
  // }

  viewllMyApproval() {
    this.viewAllMyApproval = !this.viewAllMyApproval
    this.viewLessMyApproval = !this.viewLessMyApproval
    if (this.viewLessMyApproval) {
      this.totaldataMyApproval = this.filteredMyPendingApprovals?.length;
      if (this.totaldataMyApproval > 5) {
        this.topFiveApprovalData = this.filteredMyPendingApprovals;
      }
    }
    else {
      this.GetMyApprovalData();
    }

  }
  viewll() {
    this.viewAll = !this.viewAll
    this.viewLess = !this.viewLess
    if (this.viewLess) {
      this.totaldata = this.filteredMyRequests.length;
      if (this.totaldata > 6) {
        this.topFiveMyRequestData = this.filteredMyRequests;
      }
    }
    else {
      this.GetMyRequestData();
    }

  }

  viewll2
  viewllCard() {
    this.viewll2 = !this.viewll2

  }

  //  Select all CheckBox
  mast = false;
  child1 = false
  child2 = false
  child3 = false
  child4 = false
  child5 = false
  master() {
    this.mast = this.mast;
    if (this.mast === true) {
      this.child1 = true
      this.child2 = true
      this.child3 = true
      this.child4 = true
      this.child5 = true
    }
    if (this.mast === false) {
      this.child1 = false
      this.child2 = false
      this.child3 = false
      this.child4 = false
      this.child5 = false
    }
  }

  child() {
    if (this.child1 === true && this.child2 === true && this.child3 === true && this.child4 === true) {

      this.mast = true;
    }
    else {
      this.mast = false;
    }
  }
  // CheckBox end


  // Request
  mAprvl = "assets/images/my_approvals-01.svg";
  mRequst = "assets/images/my_requests-01.svg";

  // Dropdwon
  option1
  constructor(private modalService: BsModalService, private loginService: LoginService, private appInsights: AppInsightsService,
    private router: Router, private approvalService: ApprovalService, private delegationReportsService: DelegationReportsService,
    private messageService: MessageService, private excelService: ExcelService,
    private quickDelService: QuickDeligationService, private SpinnerService: NgxSpinnerService) {


  }

  @ViewChild('selectreq') templateRefreq: TemplateRef<any>;
  @ViewChild('selectRemarks') templateRemarks: TemplateRef<any>;
  @ViewChild('approvedModal') templateRefApprove: TemplateRef<any>;
  @ViewChild('rejectTempModal') templateRefReject: TemplateRef<any>;
  @ViewChild('cancelTempModal') TemplateCancelMsg: TemplateRef<any>;
  @ViewChild('rejectbulkModal') public rejectbulkModal: ModalDirective;

  public get RoleName(): string {
    return this._roleName;
  }
  public set RoleName(value: string) {
    this._roleName = value;
  }
  public get applicationList(): string {
    return this._applicationList;
  }
  public set applicationList(value: string) {
    this._applicationList = value;
  }
  public get RequestStatus(): string {
    return this._status;
  }
  public set RequestStatus(value: string) {
    this._status = value;
  }
  public get pendingrequestId(): string {
    return this._pendingrequestId;
  }

  public set pendingrequestId(value: string) {
    this._pendingrequestId = value;
  }

  public get mypendingroleName(): string {
    return this._pendingRoleName;
  }

  public set mypendingroleName(value: string) {
    this._pendingRoleName = value;
  }

  public get pendingapplicationList(): string {
    return this._pendingapplicationList;
  }

  public set pendingapplicationList(value: string) {
    this._pendingapplicationList = value;
  }

  public get requestId(): string {
    return this._requestId;
  }

  public set requestId(value: string) {
    this._requestId = value;
  }

  //#region MyRequestsDashBoard

  onMyRequestSearch() {
    this.delegateeSapId = this.delegateeTextvalue.toString().substring(this.delegateeTextvalue.toString().length - 9, this.delegateeTextvalue.toString().length - 1);

    if (this.delegateeSapId != null && this.delegateeSapId != "") {
      this.topFiveApprovalData = this.filteredMyPendingApprovals.filter((filteredMyPendingApprovals: IApproval) => filteredMyPendingApprovals.DelegateeSAPId.toString() == this.delegateeSapId || filteredMyPendingApprovals.RequesterSAPId.toString() == this.delegateeSapId);
    }
    if (this.mypendingroleName != null) {
      this.topFiveApprovalData = this.filteredMyPendingApprovals.filter((filteredMyPendingApprovals: IApproval) => filteredMyPendingApprovals.RoleId.toString() == this.mypendingroleName);
    }
    if (this.pendingapplicationList != null) {
      this.topFiveApprovalData = this.filteredMyPendingApprovals.filter((filteredMyPendingApprovals: IApproval) => filteredMyPendingApprovals.AppId.toString() == this.pendingapplicationList);
    }
    if (this.RequestStatus != null) {
      this.topFiveApprovalData = this.filteredMyPendingApprovals.filter((filteredMyPendingApprovals: IApproval) => filteredMyPendingApprovals.RequestStatus.toString() == this.RequestStatus);
    }
    if ((this.delegateeSapId != null && this.delegateeSapId != "") && this.mypendingroleName != null) {
      this.topFiveApprovalData = this.filteredMyPendingApprovals.filter((filteredMyPendingApprovals: IApproval) => filteredMyPendingApprovals.RoleId.toString() == this.mypendingroleName && filteredMyPendingApprovals.DelegateeSAPId.toString() == this.delegateeSapId);
    }
    if (this.mypendingroleName != null && this.pendingapplicationList != null) {
      this.topFiveApprovalData = this.filteredMyPendingApprovals.filter((filteredMyPendingApprovals: IApproval) => filteredMyPendingApprovals.RoleId.toString() == this.mypendingroleName && filteredMyPendingApprovals.AppId.toString() == this.pendingapplicationList);
    }
    if ((this.delegateeSapId != null && this.delegateeSapId != "") && this.pendingapplicationList != null) {
      this.topFiveApprovalData = this.filteredMyPendingApprovals.filter((filteredMyPendingApprovals: IApproval) => filteredMyPendingApprovals.AppId.toString() == this.pendingapplicationList && filteredMyPendingApprovals.DelegateeSAPId.toString() == this.delegateeSapId ||
        filteredMyPendingApprovals.AppId.toString() == this.pendingapplicationList && filteredMyPendingApprovals.RequesterSAPId.toString() == this.delegateeSapId);
    }
    if ((this.pendingrequestId != null && this.pendingrequestId != "") && this.mypendingroleName != null && this.pendingapplicationList != null && this.RequestStatus != null) {
      this.topFiveApprovalData = this.filteredMyPendingApprovals.filter((filteredMyPendingApprovals: IApproval) => filteredMyPendingApprovals.AppId.toString() == this.pendingapplicationList && filteredMyPendingApprovals.RoleId.toString() == this.mypendingroleName && filteredMyPendingApprovals.DelegateeSAPId.toString() == this.delegateeSapId ||
        filteredMyPendingApprovals.AppId.toString() == this.pendingapplicationList && filteredMyPendingApprovals.RoleId.toString() == this.mypendingroleName && filteredMyPendingApprovals.RequesterSAPId.toString() == this.delegateeSapId);
    }
    if ((this.delegateeSapId == null || this.delegateeSapId == "") && this.mypendingroleName == null && this.pendingapplicationList == null && this.RequestStatus == null) {
      this.GetMyApprovalData();
    }
    this.myPendingfilter = false;
    return this.topFiveApprovalData;
  }

  onSearch() {

    this.delegateeSapId = this.delegateeTextvalue.toString().substring(this.delegateeTextvalue.toString().length - 9, this.delegateeTextvalue.toString().length - 1);

    if (this.delegateeTextvalue != null && this.delegateeTextvalue != "") {
      //this.delegateeSapId = this.delegateeTextvalue.toString().substring(this.delegateeTextvalue.toString().length - 9, this.delegateeTextvalue.toString().length - 1);
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.DelegateeSAPId.toString() == this.delegateeSapId);
    }

    if (this.delegateeSapId != null && this.delegateeSapId != "") {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.DelegateeSAPId.toString() == this.delegateeSapId);
    }
    if (this.applicationList != null) {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.AppId.toString() == this.applicationList);
    }
    if (this.RoleName != null) {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.RoleName.toString() == this.RoleName);
    }
    if (this.RequestStatus != null) {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.RequestStatus.toString() == this.RequestStatus);
    }
    if ((this.delegateeSapId != null && this.delegateeSapId != "") && this.RoleName != null) {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.RoleName.toString() == this.RoleName && filteredMyRequests.DelegateeSAPId.toString() == this.delegateeSapId);
    }
    if ((this.delegateeSapId != null && this.delegateeSapId != "") && this.applicationList != null) {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.AppId.toString() == this.applicationList && filteredMyRequests.DelegateeSAPId.toString() == this.delegateeSapId);
    }
    if ((this.delegateeSapId != null && this.delegateeSapId != "") && this.RequestStatus != null) {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.RequestStatus.toString() == this.RequestStatus && filteredMyRequests.DelegateeSAPId.toString() == this.delegateeSapId);
    }
    if (this.RoleName != null && this.applicationList != null) {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.RoleName.toString() == this.RoleName && filteredMyRequests.AppId.toString() == this.applicationList);
    }
    if (this.RoleName != null && this.RequestStatus != null) {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.RoleName.toString() == this.RoleName && filteredMyRequests.RequestStatus.toString() == this.RequestStatus);
    }
    if (this.applicationList != null && this.RequestStatus != null) {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.AppId.toString() == this.applicationList && filteredMyRequests.RequestStatus.toString() == this.RequestStatus);
    }
    if ((this.delegateeSapId != null && this.delegateeSapId != "") && this.RoleName != null && this.applicationList != null) {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.AppId.toString() == this.applicationList && filteredMyRequests.RoleName.toString() == this.RoleName && filteredMyRequests.DelegateeSAPId.toString() == this.delegateeSapId);
    }
    if ((this.delegateeSapId != null && this.delegateeSapId != "") && this.RoleName != null && this.RequestStatus != null) {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.RoleName.toString() == this.RoleName && filteredMyRequests.DelegateeSAPId.toString() == this.delegateeSapId && filteredMyRequests.RequestStatus.toString() == this.RequestStatus);
    }
    if ((this.delegateeSapId != null && this.delegateeSapId != "") && this.applicationList != null && this.RequestStatus != null) {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.AppId.toString() == this.applicationList && filteredMyRequests.DelegateeSAPId.toString() == this.delegateeSapId && filteredMyRequests.RequestStatus.toString() == this.RequestStatus);
    }
    if ((this.delegateeSapId != null && this.delegateeSapId != "") && this.RoleName != null && this.applicationList != null && this.RequestStatus != null) {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.AppId.toString() == this.applicationList && filteredMyRequests.RoleName.toString() == this.RoleName && filteredMyRequests.DelegateeSAPId.toString() == this.delegateeSapId && filteredMyRequests.RequestStatus.toString() == this.RequestStatus);
    }
    if ((this.delegateeSapId == null || this.delegateeSapId == "") && this.RoleName == null && this.applicationList == null && this.RequestStatus == null) {
      this.GetMyRequestData();
    }
    this.filter = false;
    return this.topFiveMyRequestData;
  }

  ngOnInit(): void {
    this.SpinnerService.show();
    this.QuickDelegation();
    this.loginService.getEmployeeId();
    this.loginService.getAuthenticationInfo(localStorage.getItem('UserName')).subscribe((resFromProfile) => {
      // if (resFromProfile.Data[0] != undefined || resFromProfile.Data[0] != null) {
      //   this.EmployeeName = resFromProfile.Data[0].EmpName;
      //   this.EmployeeSubGroup = resFromProfile.Data[0].EMEmpSubgroup;
      //   this.Designation = resFromProfile.Data[0].EMDesig;
      //   this.OnBehalf = resFromProfile.Data[0].ADVDelFlag;
      //   this.SapId = resFromProfile.Data[0].EMEmpCode;
      if (resFromProfile != undefined || resFromProfile != null) {
        this.EmployeeName = resFromProfile[0]?.EmpName;
        this.EmployeeSubGroup = resFromProfile[0]?.EMEmpSubgroup;
        this.Designation = resFromProfile[0]?.EMDesig;
        this.OnBehalf = resFromProfile[0]?.ADVDelFlag;
        this.SapId = resFromProfile[0]?.EMEmpCode;
        this.loginService.isRefreshed = true;
        this.GetMyApprovalData();
        this.GetMyRequestData();
        this.subscriptionRoleByPending = this.approvalService.getPendingRoleByAppSlider().subscribe(
          {
            next: roleByApp => {
              this.roleByAppSlider = roleByApp;
              this.roleByAppSlierApprovalLength = roleByApp.length;
              this.itemsPerSlide = 3;
              this.SpinnerService.hide();
            }
          });
        this.subScriptionRoleByRequest = this.approvalService.getRoleByAppSliderMyRequest().subscribe(
          {
            next: roleByAppMyRequest => {
              this.roleByAppSliderMyRequest = roleByAppMyRequest;
              this.roleByAppSliderLength = roleByAppMyRequest.length;
              this.itemsPerSlideRequest = 3;
              this.SpinnerService.hide();
            },
            error: err => this.errorMessage = err
          }
        );
      }
      else {
        this.router.navigate(['Unauthorized']);
        this.SpinnerService.hide();
      }
    });
  }

  ListQuickDesignation: IntegratedAppDetails[];
  QuickDelegation() {
    this.quickDelService.GetActiveApplications().subscribe(res => {
      this.ListQuickDesignation = res;
      localStorage.removeItem('services_assigned');
      localStorage.setItem('services_assigned', JSON.stringify(this.ListQuickDesignation));
    });
  }
  GetMyApprovalData() {
    this.approvalService.getPendingRequests().subscribe(
      {
        next: requests => {

          this.myPendingApprovals = requests;
          this.filteredMyPendingApprovals = requests;
          if (requests.length > 0) {
            this.hiddenBtn = false;
          }
          this.topFiveApprovalData = requests.slice(0, 5);
          //e.log('topFiveApprovalData', this.topFiveApprovalData);
          if (this.topFiveApprovalData.length < 1) {
            this.IstopFiveApprovalData = true;
          }
          this.totalRows = this.filteredMyPendingApprovals.length;
          var mypendingapplications = [];
          var mypendingappText = [];
          var mypendingappVal = [];
          mypendingapplications = [{ label: 'Select', value: null }];
          mypendingappVal = this.filteredMyPendingApprovals.map(a => a.AppId).filter((value, index, self) => self.indexOf(value) === index);
          mypendingappText = this.filteredMyPendingApprovals.map(a => a.ApplicationCode).filter((value, index, self) => self.indexOf(value) === index);
          for (var i = 0; i < mypendingappVal.length; i++) {
            mypendingapplications.push({ label: mypendingappText[i], value: mypendingappVal[i] });
          }
          this.mypendingApplication = mypendingapplications;

          var mypendingroles = [];
          var mypendingroleName = [];
          var mypendingroleVal = [];
          mypendingroles = [{ label: 'Select', value: null }];
          mypendingroleVal = this.filteredMyPendingApprovals.map(a => a.RoleId).filter((value, index, self) => self.indexOf(value) === index);
          mypendingroleName = this.filteredMyPendingApprovals.map(a => a.RoleName).filter((value, index, self) => self.indexOf(value) === index);
          for (var i = 0; i < mypendingroleVal.length; i++) {
            mypendingroles.push({ label: mypendingroleName[i], value: mypendingroleVal[i] });
          }
          this.mypendingRole = mypendingroles;

          var pendingStatus = [];
          var appPendingStatus = 'Pending';
          pendingStatus = [{ label: 'Select', value: null }];
          /*appPendingStatus = this.filteredMyRequests.map(a => a.RequestStatus).filter((value, index, self) => self.indexOf(value) === index);
          //status.push({ label: appStatus[i], value: appStatus[i] });
          for (var i = 0; i < appPendingStatus.length; i++) {
            pendingStatus.push({ label: appPendingStatus[i], value: appPendingStatus[i] });
          }*/
          pendingStatus.push({ label: appPendingStatus, value: appPendingStatus });
          this.PendingStatus = pendingStatus;

          this.SpinnerService.hide();
        },
        error: err => this.errorMessage = err
      });
  }

  GetMyRequestData() {
    this.subScriptionMyRequests = this.approvalService.getMyRequest().subscribe(
      {
        next: requestsList => {
          this.myRequests = requestsList;
          this.topFiveMyRequestData = requestsList.slice(0, 6);
          if (this.topFiveMyRequestData.length < 1) {
            this.IstopFiveMyRequestData = true;
          }
          this.filteredMyRequests = requestsList;
          this.totalRequestRows = this.filteredMyRequests.length;

          var applications = [];
          var appText = [];
          var appVal = [];
          applications = [{ label: 'Select', value: null }];
          appVal = this.filteredMyRequests.map(a => a.AppId).filter((value, index, self) => self.indexOf(value) === index);
          appText = this.filteredMyRequests.map(a => a.ApplicationCode).filter((value, index, self) => self.indexOf(value) === index);
          for (var i = 0; i < appVal.length; i++) {
            applications.push({ label: appText[i], value: appVal[i] });
          }
          this.application = applications;

          var roles = [];
          var roleName = [];
          var roleVal = [];
          roles = [{ label: 'Select', value: null }];
          roleVal = this.filteredMyRequests.map(a => a.RoleId).filter((value, index, self) => self.indexOf(value) === index);
          roleName = this.filteredMyRequests.map(a => a.RoleName).filter((value, index, self) => self.indexOf(value) === index);
          for (var i = 0; i < roleVal.length; i++) {
            roles.push({ label: roleName[i], value: roleName[i] });
          }
          this.Role = roles;


          var status = [];
          var appStatus = [];
          status = [{ label: 'Select', value: null }];
          appStatus = this.filteredMyRequests.map(a => a.RequestStatus).filter((value, index, self) => self.indexOf(value) === index);
          for (var i = 0; i < appStatus.length; i++) {
            status.push({ label: appStatus[i], value: appStatus[i] });
          }
          this.Status = status;

          this.SpinnerService.hide();
        },
        error: err => this.errorMessage = err
      });
    this.showContent = true;
  }
  calcluateDateDiff(endDateIn, startDateIn) {
    let startDate = new Date(startDateIn);
    let endDate = new Date(endDateIn);
    return Math.floor((Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()) - Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate())) / (1000 * 60 * 60 * 24))
  }

  onReject(del_ReqId): void {
    this.delReqId = Number(del_ReqId);
    this.rejectRemarks = null;
    this.activeSubmitButton = true;
  }

  onRejectRequest(): void {

    //if (this.rejectRemarks != null) {

    const employee = <IEmployee>{
      ReqId: this.delReqId,
      SAPID: this.SapId,//localStorage.getItem("SapId"),
      Remarks: this.rejectRemarks
    }
    this.listRejectRequest.push(employee);
    this.approvalService.postRejectRequest(this.listRejectRequest)
      .subscribe({
        next: () => this.alert(this.templateRefReject),
        complete: () => this.onSaveComplete(),
        error: err => this.errorMessage = err
      });
    // }
    // else {
    //   this.alert(this.templateRemarks);
    // }

  }

  onApproveRequest(Del_ReqId): void {

    const employee = <IEmployee>{
      ReqId: Del_ReqId,
      SAPID: this.SapId,//localStorage.getItem("SapId"),
      Remarks: null
    }
    this.listApproveRequest.push(employee);

    this.approvalService.postApproveRequest(this.listApproveRequest)
      .subscribe({
        complete: () => {
          this.onSaveComplete(),
            this.alertbulk(this.templateRefApprove)
        },
        error: err => this.errorMessage = err
      });
  }

  maincheckbox(event: any) {
    if (event == 'A') {
      this.gridcheckval = true;
      for (let a = 0; a < this.filteredMyPendingApprovals.length; a++) {
        const employee = <IEmployee>{
          ReqId: this.filteredMyPendingApprovals[a].Del_ReqId,
          SAPID: this.SapId,//localStorage.getItem("SapId"),
          Remarks: null
        }
        this.listAllApproveRequest.push(employee);
      }

    }
    else {
      this.gridcheckval = false;
      this.listAllApproveRequest.splice(0, this.listAllApproveRequest.length);

    }
  }

  maincheckboxDelreqId(event: any, delreqID) {

    if (event.target.checked) {

      const employee = <IEmployee>{
        ReqId: delreqID,
        SAPID: this.SapId, //localStorage.getItem("SapId"),
        Remarks: null
      }
      this.listAllApproveRequest.push(employee);


    }
    else {

      for (var i = this.listAllApproveRequest.length; i--;) {
        if (this.listAllApproveRequest[i].ReqId === delreqID) { this.listAllApproveRequest.splice(i, 1); }
      }


    }
  }

  bulkApprove() {
    if (this.listAllApproveRequest.length > 0) {

      this.approvalService.postApproveRequest(this.listAllApproveRequest)
        .subscribe({
          complete: () => {
            this.onSaveComplete(),
              this.alertbulk(this.templateRefApprove)
          },
          error: err => this.errorMessage = err
        });

    }
    else {
      this.alert(this.templateRefreq);
    }

  }

  bulkReject() {

    for (let z = 0; z < this.listAllApproveRequest.length; z++) {
      this.listAllApproveRequest[z].Remarks = this.rejectBulkRemarks;
    }

    //if (this.rejectBulkRemarks != null) {
    // this.RemarksCheck = false;
    this.approvalService.postRejectRequest(this.listAllApproveRequest)
      .subscribe({
        complete: () => {
          this.onSaveComplete(),
            this.alertbulk(this.templateRefReject)
        },
        error: err => this.errorMessage = err
      });
    // }
    // else {
    //   this.alert(this.templateRemarks);
    //   //this.RemarksCheck = true;
    // }

  }
  onBulkReject(): void {
    this.rejectBulkRemarks = null;
  }

  checkRejectselect() {

    if (this.listAllApproveRequest.length > 0) {
      this.rejectbulkModal.show();
    }
    else {
      this.visible = true;
      //this.alert(this.templateRefreq);
    }
  }
  //RemarksConsen: boolean;
  // public rejMessage(rejectRemarks: string) {

  //   if (this.rejectRemarks !== null || this.rejectBulkRemarks != null) {
  //     this.RemarksCheck = false;
  //   }
  //   else {
  //     this.RemarksCheck = true;
  //   }
  //   this.DisableBUtton();
  // }

  rejMessage() {
    if (this.rejectRemarks.length > 0 || this.rejectBulkRemarks.length > 0) {
      //this.ValidationMessage = "";
      this.activeSubmitButton = false;
    }
    else {
      //this.ValidationMessage = "Remarks is Mandatory";
      this.activeSubmitButton = true;
    }
    this.DisableBUtton();
  }

  DisableBUtton() {
    if (this.activeSubmitButton) {
      return "disableButton";
    }
    else {
      return "";
    }
  }
  cancelMsg() {
    if (this.cancelRemarks.length > 0) {
      this.canValMessage = "";
      this.activeCancelBtn = false;
    }
    else {
      this.canValMessage = "Remarks is Mandatory";
      this.activeCancelBtn = true;
    }
    this.DisableCancelBtn();
  }

  DisableCancelBtn() {
    if (this.activeCancelBtn) {
      return "canDisableButton";
    }
    else {
      return "";
    }
  }

  setCancelReqId(cancelRequest: IApproval) {
    this.setcancelId = cancelRequest.Del_ReqId;
    this.cancelRemarks = null;
    this.activeCancelBtn = true;
    //e.log("In cancel method of My Request and requestStaus is : " + cancelRequest.RequestStatus);
  }

  OnCancelRequest() {

    //if (this.cancelRemarks != null) {
    const employee = <IEmployee>{
      ReqId: this.setcancelId,
      SAPID: this.SapId,//localStorage.getItem("SapId"),
      Remarks: this.cancelRemarks
    }
    this.approvalService.postCancelRequest(employee)
      .subscribe({
        next: () => this.alert(this.TemplateCancelMsg),
        complete: () => {
          setTimeout(() => {
            this.onSaveComplete();
          }, 2000);
        },
        error: err => this.errorMessage = err
      });
    // }
    // else {
    //   this.alert(this.templateRemarks);
    // }
  }

  downloadFile(DocumentId, DocumentPath, event) {
    var FileSaver = require('file-saver');
    var files = event.files;
    const addfile = <IDocument>{
      DocName: DocumentPath
    }
    this.filename = addfile;
    this.subScriptionDocumentNameDetails = this.approvalService.getDocumentByDatails(this.filename).subscribe(
      {
        next: requestsList => {
          this.myDocuments = requestsList.fileByteArray;
          var ext = DocumentPath.split('.').pop();
          this.openFile(requestsList.fileByteArray, DocumentPath, ext);


          // if (ext == 'png') {
          //   this.dwnldFile = "data:image/png;base64," + this.myDocuments;
          // }
          // else if (ext == 'jpeg') {
          //   this.dwnldFile = "data:image/jpeg;base64," + this.myDocuments;
          // }
          // else if (ext == 'gif') {
          //   this.dwnldFile = "data:image/gif;base64," + this.myDocuments;
          // }
          // else if (ext == 'pdf') {
          //   this.dwnldFile = "data:application/pdf;base64," + this.myDocuments;
          // }
          // else if (ext == 'jpg') {
          //   this.dwnldFile = "data:image/jpg;base64," + this.myDocuments;
          // }
          // else if (ext == 'msg') {
          //   this.dwnldFile = "data:image/msg;base64," + this.myDocuments;
          // }
          // else {
          //   let str: string = 'Invalid file extension';
          // }
          // const employee = <IEmployee>{
          //   SAPID: this.SapId,//localStorage.getItem("SapId"),
          //   Remarks: null
          // }
          // this.downloadsapid.push(employee);
          // this.downloadextensionsapid = this.downloadsapid[0].SAPID;
          // var filename = DocumentPath.split('.').slice(0, -1).join(".");

          // FileSaver.saveAs(this.dwnldFile, filename + "_" + this.downloadextensionsapid + "_" + this.datetoday + "." + ext);
        }
      });
  }

  openFile(path: any, docLink: string, ext): void {
    const uri = 'data: ' + this.onResponseContentType(ext) + ';base64, ' + encodeURI(path);
    const downloadLink = document.createElement('a');
    downloadLink.href = uri;
    downloadLink.download = docLink;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }


  onResponseContentType(extension: string): string {
    if (!extension.startsWith('.')) {
      extension = '.' + extension;
    }

    switch (extension.toLowerCase()) {
      case '.docx':
      case '.doc':
        return 'application/msword';
      case '.csv':
      case '.xls':
      case '.xlsx':
        return 'application/vnd.ms-excel';
      case '.txt':
        return 'text/plain';
      case '.jpg':
      case '.jpeg':
        return 'image/jpeg';
      case '.gif':
        return 'image/gif';
      case '.png':
        return 'image/png';
      case '.pdf':
        return 'application/pdf';
      case '.msg':
        //return 'application/vnd.contact.cmsg';
        return 'application/vsd.ms-outlook';
      default:
        return 'application/octet - stream';
    }
  }

  navigation(): string {
    if (this.roleByAppSliderLength < 5) {
      return "showNavigation";
    }
    else {
      return "";
    }
  }

  navigationApprove(): string {
    if (this.roleByAppSlierApprovalLength < 5) {
      return "showNavigation";
    }
    else {
      return "";
    }
  }

  ClearData() {
    this.applicationList = null,
      this.RoleName = null,
      this.delegateeTextvalue = null,
      this.pendingrequestId = null,
      this.pendingapplicationList = null,
      this.mypendingroleName = null,
      this.RequestStatus = null,
      this.PendingStatus = null
  }


  onSaveComplete(): void {
    this.GetMyApprovalData();
    this.GetMyRequestData();
  }

  updateDelegateeId(event) {
    this.delegateeSapId = this.delegateeTextvalue.toString().substring(this.delegateeTextvalue.toString().length - 9, this.delegateeTextvalue.toString().length - 1);
  }

  textValue(event) {
    if (this.delegateeTextvalue.length > 4) {
      const sapId = <SAPID>
        {
          ReqSAPID: this.delegateeTextvalue,
        }
      this.delegationReportsService.fetchEmployeeSuggestions(this.delegateeTextvalue).subscribe(
        {
          next: data => {
            this.recentDelegatee = data;
            //e.log("Delegatee", this.recentDelegatee);
          },
          error: err => this.errorMessage = err
        });
    }
  }
  onClickDelegateonKeyUp(event) {
    if (this.delegateegridTextvalue.length > 4) {
      const sapId = <SAPID>
        {
          ReqSAPID: this.delegateegridTextvalue,
        }
      this.delegationReportsService.fetchEmployeeSuggestions(this.delegateegridTextvalue).subscribe(
        {
          next: data => {
            this.recentDelegatee = data;

          },
          error: err => this.errorMessage = err
        });
    }
  }

  bindRecentDelegatee() {
    this.brands = [];
    for (let i = 0; i < this.recentDelegatee?.length; i++) {
      this.brands[i] = this.recentDelegatee[i].EmpName + '(' + this.recentDelegatee[i].SAPID + ')';
    }
  }

  filterBrands(event) {

    this.bindRecentDelegatee();
    this.filteredBrands = [];
    for (let i = 0; i < this.brands.length; i++) {
      this.filteredBrands.push(this.brands[i]);
    }
  }

  //For grid Filter
  filterGridBrands(event) {
    //this.brands = [''];
    this.bindRecentDelegatee();
    this.filteredGridBrands = [];
    for (let i = 0; i < this.brands.length; i++) {
      this.filteredGridBrands.push(this.brands[i]);
    }
  }


  OnSelectApproverGrid(event) {

    //this.delegateeSapId = this.delegateegridTextvalue.toString().substring(this.delegateegridTextvalue.toString().length - 9, this.delegateegridTextvalue.toString().length - 0);
    this.delegateeSapId = this.delegateegridTextvalue.match(/\(([^)]+)\)/)[1];
    if (this.delegateeSapId != null && this.delegateeSapId != "") {
      this.topFiveApprovalData = this.filteredMyPendingApprovals.filter((filteredMyPendingApprovals: IApproval) => filteredMyPendingApprovals.DelegateeSAPId.toString() == this.delegateeSapId || filteredMyPendingApprovals.RequesterSAPId.toString() == this.delegateeSapId);
    }
    if (this.delegateeSapId == null || this.delegateeSapId == "") {
      this.GetMyApprovalData();
    }
    return this.topFiveApprovalData;
  }
  OnSelectRequestorGrid(event) {

    //this.delegateeSapId = this.delegateegridTextvalue.toString().substring(this.delegateegridTextvalue.toString().length - 9, this.delegateegridTextvalue.toString().length - 0);
    this.delegateeSapId = this.delegateegridTextvalue.match(/\(([^)]+)\)/)[1];
    if (this.delegateeSapId != null && this.delegateeSapId != "") {
      this.topFiveMyRequestData = this.filteredMyRequests.filter((filteredMyRequests: IApproval) => filteredMyRequests.DelegateeSAPId.toString() == this.delegateeSapId);
    }
    if (this.delegateeSapId == null || this.delegateeSapId == "") {
      this.GetMyRequestData();
    }
    return this.topFiveMyRequestData;
  }

  changeTab() {
    this.ClearData();
    this.delegateegridTextvalue = null;
    this.viewllMyApproval();
    this.viewll();
  }
}
